import api from "!../../noodl-react-ui/module/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../noodl-react-ui/module/node_modules/css-loader/dist/cjs.js!./index.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};